import { render, staticRenderFns } from "./map.vue?vue&type=template&id=6587b508"
import script from "./map.vue?vue&type=script&lang=js"
export * from "./map.vue?vue&type=script&lang=js"
import style0 from "./map.vue?vue&type=style&index=0&id=6587b508&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6587b508')) {
      api.createRecord('6587b508', component.options)
    } else {
      api.reload('6587b508', component.options)
    }
    module.hot.accept("./map.vue?vue&type=template&id=6587b508", function () {
      api.rerender('6587b508', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/map.vue"
export default component.exports